import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { theme } from '../../../components/muiTheme';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import GlobalAccountFilter from './GlobalAccountFilter';
import { useAuthStore } from '../../../contexts/AuthContext';
import MenuDropdown from '../../../components/reusable-components/MenuDropdown';
import { useState, useRef, memo } from 'react';
import { logout } from '../../../apiCalls/auth';
import AccountUsage from '../../../components/reusable-components/AccountUsage';

function Navbar() {
    const { user } = useAuthStore();
    const isSuperAdmin = user?.isSuperAdmin;
    const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
    const [limitsPopperAnchorEl, setLimitsPopperAnchorEl] = useState(null);
    const [arrow, setArrow] = useState(false)
    const userMenuList = [{ name: "Logout", handleFunc: logout, styledProps: { width: "63px", color: "#F5325B" } }]
    const [showLimitsPopper, setShowLimitsPopper] = useState(false);
    const limitsButtonRef = useRef(null);
    const userMenuButtonRef = useRef(null);

    const handleLimitsClick = () => {
        setLimitsPopperAnchorEl(prevAnchor => prevAnchor ? null : limitsButtonRef.current);
        setShowLimitsPopper(prevShow => !prevShow);
    };
    const closeLimitsPopper = () => {
        setShowLimitsPopper(false);
        setLimitsPopperAnchorEl(null);
    };

    const handleUserMenuClick = () => {
        setUserMenuAnchorEl(prevAnchor => prevAnchor ? null : userMenuButtonRef.current);
        setArrow(prevArrow => !prevArrow);
    };

    return (
        <Grid container direction='row' alignItems='center' marginRight='20px' spacing={2.5}
        >
            <AccountUsage
                open={showLimitsPopper}
                anchorEl={limitsPopperAnchorEl}
                placement="bottom-start"
                style={{ zIndex: 1300 }}
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 8],
                        },
                    },
                ]}
                onClickAway={closeLimitsPopper}
                buttonRef={limitsButtonRef}
                iconColor={theme.palette.white.main}
                handleClick={handleLimitsClick}
            />
            <NavbarIconButton
                handleClick={handleUserMenuClick}
                buttonRef={userMenuButtonRef}
            >
                <PersonOutlinedIcon fontSize='inherit' />
            </NavbarIconButton>
            <MenuDropdown
                id={`user-menu-button`}
                anchorEl={userMenuAnchorEl}
                setAnchorEl={setUserMenuAnchorEl}
                optionList={userMenuList}
                arrow={arrow}
                setArrow={setArrow}
            />
            {isSuperAdmin ? <Grid item>
                <GlobalAccountFilter />
            </Grid> : null}
        </Grid>
    )
}
export default memo(Navbar);

function NavbarIconButton({ children, handleClick, buttonRef }) {
    return (
        <Grid item>
            <IconButton
                ref={buttonRef}
                sx={{
                    color: theme.palette.white.main,
                    height: '24px',
                    padding: '0px',
                }}
                onClick={handleClick}
            >
                {children}
            </IconButton>
        </Grid>
    )
}